import { createContext, useContext, useReducer } from "react";

const UserContext = createContext<any>("user");
UserContext.displayName = "UserContext";

export type UserContextType = {
  status: string | null;
  error: any;
  isAuthenticated: boolean;
  user: UserType;
};

export type UserType = {
  email: string;
  email_verified: boolean;
  app_metadata: any;
  roles: any;
  name: string;
  nickname: string;
  picture: string;
  sub: string;
  updated_at: string;
};

const initialState: UserContextType = {
  status: null,
  error: null,
  isAuthenticated: false,
  user: {
    email: "",
    email_verified: false,
    app_metadata: {},
    roles: {},
    name: "",
    nickname: "",
    picture: "",
    sub: "",
    updated_at: "",
  },
};

function userReducer(state: any, action: any) {
  switch (action.type) {
    case "start update": {
      return {
        ...state,
        user: { ...state.user, ...action.updates },
        status: "pending",
      };
    }
    case "finish update": {
      return {
        ...state,
        user: action.updatedUser,
        status: "resolved",
        error: null,
        isAuthenticated: true,
      };
    }
    case "fail update": {
      return {
        ...state,
        status: "rejected",
        error: action.error,
        user: state.storedUser,
      };
    }
    case "reset": {
      return {
        ...state,
        status: null,
        error: null,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }: any) {
  const [state, dispatch] = useReducer(userReducer, initialState);

  const value = { state, dispatch };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

function useUser() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error(`useUser must be used within a UserProvider`);
  }
  return context;
}

export { UserProvider, useUser };
